import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53ff2f3a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=53ff2f3a&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=53ff2f3a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff2f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ff2f3a')) {
      api.createRecord('53ff2f3a', component.options)
    } else {
      api.reload('53ff2f3a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=53ff2f3a&scoped=true", function () {
      api.rerender('53ff2f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/whole/index.vue"
export default component.exports